<template>
    <van-calendar v-model="showDate" :min-date="minDate" :max-date="maxDate" @confirm="onConfirm" type="range" :round="round" :allowSameDay="allowSameDay"/>
</template>
<script>
    import moment from 'moment'
    export default {
        props: {
            minDate: {// 自定义默认时间
                type: Date,
                default: () => {
                    return new Date(2020, 4, 20)
                }
            },
            maxDate: {
                type: Date,
                default: () => {
                    return new Date(2025, 11, 31)
                }
            },
            round: {
                type: Boolean,
                default: false
            },
            allowSameDay: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                showDate: false
            }
        },
        created () {

        },
        methods: {
            showTime () {
                this.showDate = true;
            },
            formateTime (value) {
                return moment(value).format('YYYY-MM-DD');
            },
            onConfirm (value) {
                const [start, end] = value;
                const startTime = this.formateTime(start) + ' 00:00:00';
                const endTime = this.formateTime(end) + ' 59:59:59';
                const arrTime = [startTime, endTime];
                this.$emit('getCurrentTime', arrTime);
                this.showDate = false;
            }
        }
    }
</script>
<style lang="less" scoped>
</style>
<style>
.van-calendar__popup.van-popup--bottom, .van-calendar__popup.van-popup--top{
    height: 70% !important;
  }
.van-button--danger{
    background-color: #36B374;
    border: 0.026667rem solid #36B374;
}
.van-calendar__day--middle{
    color:#666;
}
/* /deep/.van-calendar__day{
    width:49px;
    height:49px;
}
/deep/.van-calendar{
    width:100%;
    padding:0 16px!important;
    background-color:transparent!important;
} */

.van-calendar__day--middle::after {
    background-color: #36B374;
}
.van-calendar__day--end, .van-calendar__day--multiple-middle, .van-calendar__day--multiple-selected, .van-calendar__day--start, .van-calendar__day--start-end{
    background-color: #36B374;
}
</style>
